// src/components/Header.js
import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  HStack,
  VStack,
  IconButton,
  Spacer,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '../slide.css';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';

const SlideShow = () => {
  return (
    <Box w="800px">
      <Flex align="center">
        <Swiper
        slidesPerView={1}
        spaceBetween={5}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide><img src="/banner/bpr01.png" /></SwiperSlide>
        <SwiperSlide><img src="/banner/bpr02.png" /></SwiperSlide>
      </Swiper>
      </Flex>
    </Box>
  );
};

export default SlideShow;
